import { useMemo } from 'react';

import { CheckboxGroup, CheckboxGroupValue } from '@dreryk/react-components';

import { medicalDevicesTranslationKeys } from '../../translations';
import {
   MedicalDeviceOrderFormRegister,
   MedicalDeviceOrderFormWatch,
   MedicalDeviceOrderPlacementFormBeanPart,
} from '../medicalDeviceOrder.types';
import { isMedicalDeviceFieldRequired } from '../medicalDeviceOrder.utils';

type PlacementFieldProps = {
   readonly register: MedicalDeviceOrderFormRegister<MedicalDeviceOrderPlacementFormBeanPart>;
   readonly watch: MedicalDeviceOrderFormWatch;
};

export const PlacementField = (props: PlacementFieldProps): JSX.Element => {
   const placementCheckboxValues: CheckboxGroupValue[] = useMemo(
      () => [
         {
            key: 'LEFT',
            label: medicalDevicesTranslationKeys.fields.leftSided,
            defaultValue: false,
         },
         {
            key: 'RIGHT',
            label: medicalDevicesTranslationKeys.fields.rightSided,
            defaultValue: false,
         },
      ],
      []
   );
   return (
      <CheckboxGroup
         testId={'placement'}
         label={medicalDevicesTranslationKeys.fields.placement}
         controller={props.register('placement', { required: isMedicalDeviceFieldRequired(props.watch, 'placement') })}
         availableValues={placementCheckboxValues}
         horizontal
      />
   );
};
